async function r(i,n){return fetch(i,{signal:n}).then(o=>o.json())}export{r as getFormDefinition};
